/**
 * @generated SignedSource<<ee198e678a104016fa334f256e4254cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatbotFirstStepForm_Query$variables = {};
export type ChatbotFirstStepForm_QueryVariables = ChatbotFirstStepForm_Query$variables;
export type ChatbotFirstStepForm_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ChatbotDistributionSettingFields_root">;
};
export type ChatbotFirstStepForm_QueryResponse = ChatbotFirstStepForm_Query$data;
export type ChatbotFirstStepForm_Query = {
  variables: ChatbotFirstStepForm_QueryVariables;
  response: ChatbotFirstStepForm_Query$data;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatbotFirstStepForm_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChatbotDistributionSettingFields_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ChatbotFirstStepForm_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceConnection",
        "kind": "LinkedField",
        "name": "sources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Source",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fec5fd2d3d47cf62d16884bb324cc216",
    "id": null,
    "metadata": {},
    "name": "ChatbotFirstStepForm_Query",
    "operationKind": "query",
    "text": "query ChatbotFirstStepForm_Query {\n  ...ChatbotDistributionSettingFields_root\n}\n\nfragment ChatbotDistributionSettingFields_root on Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};

(node as any).hash = "19f02aef0cf2f42f56fa1d2d52e001f5";

export default node;
